import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "reactstrap";

import Product from '../../components/products/Product'
import { StoreService } from '../../services/storeService';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import toastr, { success } from 'toastr'
import LoginRequiredModal from '../authentication/LoginRequiredModal';

export default function ProductList({ products }) {

    const storeService = new StoreService();
    const [store, setStore] = useState([])
    const params = useParams();
    const [favoritos, setFavoritos] = useState([])
    const user = useSelector(x => x.Login.user);
    const [modalLogin, setModalLogin] = useState(false);

    useEffect(() => {
        getActiveStores();
        getList();   
    }, [])

    const getActiveStores = async () => {
        const data = await storeService.getActive();
        if (data)
            setStore(data.find(x => x.id == params.id));
    }

    const addFavoritos = async (IdPersona, idProducto) => {
        const response = await storeService.addFav(IdPersona, idProducto);
        let favorites = favoritos
        if (response.success) {
            toastr.success("Agregado a favoritos");

        } else {
            toastr.info("Error no fue agregado a favoritos");
        }
        getList();
    }
    const getList = async () => {
        if (user) {
            const data = await storeService.getFavList(user.id);
            if (data)
                setFavoritos(data);
        }
    }
    const deleteFavorite = async (IdPersona, idProducto) => {
        const response = await storeService.deleteFav(IdPersona, idProducto);
        // if (response.success) {
        //     toastr.success("Eliminado");

        // }else{
        //     toastr.info("pailax");
        // }
        getList();
    }
    const toggleFavorite = async (id, estado) => {
        if (!user) {
            setModalLogin(true);
            return;
        }
    
        if (estado) {
            await addFavoritos(user.id, id);
        } else {
            await deleteFavorite(user.id, id);
        }
    };

    return (
        <React.Fragment>
            <div className="panel panel-secundary">
                <div className="panel-body">
                    {store && (
                        <Row sm="12">
                            <Col className="col-4 text-center mb-3">
                                {/* <a href={`/storeProducts/${store.id}`}>
                                    <img
                                        src={store.logo}
                                        alt={store.nombre}
                                        style={{ height: "80px", width: "80px" }}
                                    />
                                </a> */}
                            </Col>
    
                            <Col className="col-4 text-center mb-4">
                                <h2>{products.length} Productos</h2>
                            </Col>
    
                            <Col className="col-4 text-right mb-4">
                                <Button href={"/home"}>Volver</Button>
                            </Col>
                        </Row>
                    )}
                </div>
            </div>
    
            <Row>
                {products
                .filter(item => item.productDetailModel.idTienda === 10018)
                .map((item, key) => (
                    <Product
                        key={key}
                        toggleFavorite={toggleFavorite}
                        product={{
                            id: item.productDetailModel.id,
                            image: item.productDetailModel.fotoPrincipal,
                            name: item.productDetailModel.descripcion,
                            store: item.productDetailModel.nombreTienda,
                            rating: item.productDetailModel.calificacion,
                            newPrice:
                                user && user.autorizadoClienteCorp
                                    ? `$ ${new Intl.NumberFormat("de-DE").format(
                                          Math.round(item.productDetailModel.valorCorp)
                                      )}`
                                    : `$ ${new Intl.NumberFormat("de-DE").format(
                                          Math.round(item.productDetailModel.valor)
                                      )}`,
                            lastPrice:
                                user && user.autorizadoClienteCorp
                                    ? `$ ${new Intl.NumberFormat("de-DE").format(
                                          Math.round(
                                              item.productDetailModel.valorCorp +
                                                  (item.productDetailModel.valorCorp *
                                                      item.productDetailModel.descuentoCorp) /
                                                      100
                                          )
                                      )}`
                                    : `$ ${new Intl.NumberFormat("de-DE").format(
                                          Math.round(
                                              item.productDetailModel.valor +
                                                  (item.productDetailModel.valor *
                                                      item.productDetailModel.descuento) /
                                                      100
                                          )
                                      )} `,
                            price: user && user.autorizadoClienteCorp
                                ? item.productDetailModel.valorCorp
                                : item.productDetailModel.valor,
                            idStore: item.productDetailModel.idTienda,
                            Referencia: item.productDetailModel.referencia,
                            Iva: user && user.autorizadoClienteCorp
                                ? item.productDetailModel.ivaCorp
                                : item.productDetailModel.iva,
                            Descuento: user && user.autorizadoClienteCorp
                                ? item.productDetailModel.descuentoCorp
                                : item.productDetailModel.descuento,
                            favorite: favoritos.find((a) => a.id === item.productDetailModel.id),
                        }}
                    />
                ))}
            </Row>
    
            <LoginRequiredModal isOpen={modalLogin} toggle={() => setModalLogin(false)} />
        </React.Fragment>
    );
    
}